<form [formGroup]="frmGroup">
  <div style="display: flex; " *ngIf = !InputConfig?.isHidden>
   <div style="flex: .25">
    <label *ngIf="fieldInfo.showLabel" [fieldInfo]="fieldInfo" acForLable>
      {{ fieldInfo.label }}<span *ngIf="fieldInfo.validation?.required">*</span>
    </label>
   </div>
  <div style="flex: 1">
  <hcc-custom-validation
    *ngIf="fieldInfo.validation; else withoutValidation"
    [validations]="fieldInfo.validation"
  >
    <div class="date-time-row">
      <div class="input-group date-field nopadding date-input-group">
        <input
          type="text"
          class="form-control input-sm"
          placement="bottom"
          [value]="selectedDate ? (selectedDate | date:displayDateFormat) : ''"
          inputValidateRef
          [control]="control"
          [formGroup]="frmGroup"
          [bsConfig]="datepickerConfig"
          [isOpen]="isCalanderOpen"
          [maxDate]="InputConfig.datePickerConfig.maxDate"
          [minDate]="InputConfig.datePickerConfig.minDate"
          #dp="bsDatepicker"
          hccDateFormat
          (bsValueChange)="onChange($event)"
          bsDatepicker
          [formControlName]="control"
          [readOnly]="InputConfig?.isDisabled"
          [hidden] = "InputConfig?.isHidden"
        />
        <div
          class="input-group-append"
          *ngIf="InputConfig.datePickerConfig.isCalanderRequired"
        >
          <span class="input-group-text pointer" (click)="calanderClicked()">
            <span class="fas fa-calendar-alt"></span>
          </span>
        </div>
      </div>
      <div class="hour-selector">
        <select
          id="hour-select-with-validation"
          class="form-control input-sm hour-selector-input"
          [value]="selectedHour"
          (change)="onHourChange($event)"
          [disabled]="InputConfig?.isDisabled"
        >
          <option *ngFor="let hour of hourOptions" [value]="hour">
            {{ hour < 10 ? '0' + hour : hour }}:00
          </option>
        </select>
      </div>
    </div>
  </hcc-custom-validation>
  </div>
  </div>
  <ng-template #withoutValidation>
    <div class="date-time-row">
      <div class="input-group date-field nopadding date-input-group">
        <input
          type="text"
          class="form-control input-sm"
          placement="bottom"
          [value]="selectedDate ? (selectedDate | date:displayDateFormat) : ''"
          inputValidateRef
          [control]="control"
          [formGroup]="frmGroup"
          [bsConfig]="datepickerConfig"
          [isOpen]="isCalanderOpen"
          [maxDate]="InputConfig.datePickerConfig.maxDate"
          [minDate]="InputConfig.datePickerConfig.minDate"
          #dp="bsDatepicker"
          hccDateFormat
          (bsValueChange)="onChange($event)"
          bsDatepicker
          [formControlName]="control"
          [readOnly]="InputConfig?.isDisabled"
          [hidden] = "InputConfig?.isHidden"
        />
        <div
          class="input-group-append"
          *ngIf="InputConfig.datePickerConfig.isCalanderRequired"
        >
          <span class="input-group-text pointer" (click)="calanderClicked()">
            <span class="fas fa-calendar-alt"></span>
          </span>
        </div>
      </div>
      <div class="hour-selector">
        <select
          id="hour-select-without-validation"
          class="form-control input-sm hour-selector-input"
          [value]="selectedHour"
          (change)="onHourChange($event)"
          [disabled]="InputConfig?.isDisabled"
        >
          <option *ngFor="let hour of hourOptions" [value]="hour">
            {{ hour < 10 ? '0' + hour : hour }}:00
          </option>
        </select>
      </div>
    </div>
  </ng-template>
</form>
